import React, {
  FunctionComponent,
  ChangeEvent,
  useState,
  useEffect,
} from "react";
import { ChoiceList } from "@cmsgov/ds-medicare-gov";
import CCXPBaseDrop from "./CCXPBaseDrop";

interface Props {
  type?: "checkbox" | "radio";
  label: string;
  values: Array<string>;
  hint?: React.ReactNode;
  options: { label: string; value: string }[];
  onUpdate: (value: string[]) => void;
  noColorChange?: boolean;
  size?: "wide" | "widest";
}

const CCXPMultiSelect: FunctionComponent<Props> = ({
  type = "checkbox",
  label,
  hint,
  values = [],
  options,
  onUpdate,
  noColorChange,
  size,
}) => {
  const [currentSelection, setCurrentSelection] = useState<string[]>([]);
  const [choices, setChoices] = useState<
    {
      label: string;
      value: string;
      checked?: boolean;
    }[]
  >([]);

  useEffect(() => {
    setCurrentSelection(values);
    setChoices(applyCheckedOptions(values));
  }, [values]);

  const applyCheckedOptions = (values: string[]) =>
    options.map(o => ({
      ...o,
      checked: values.includes(o.value),
    }));

  return (
    <CCXPBaseDrop
      label={label}
      onApply={() => onUpdate(currentSelection)}
      onClear={() => {
        setCurrentSelection([]);
        setChoices(applyCheckedOptions([]));
      }}
      onMenuOpen={() => {
        setCurrentSelection(values);
        setChoices(applyCheckedOptions(values));
      }}
      onMenuClose={() => {
        setCurrentSelection([]);
        setChoices(applyCheckedOptions([]));
      }}
      hasValue={noColorChange ? false : values.length > 0}
      size={size}
    >
      <ChoiceList
        className="ds-u-margin--0"
        type={type}
        name={label}
        hint={hint}
        labelClassName="ds-u-visibility--screen-reader"
        label={label}
        choices={choices}
        onChange={(event: ChangeEvent<HTMLInputElement>): void => {
          const { checked, value } = event.currentTarget;

          const selection =
            checked && !currentSelection.includes(value)
              ? [...currentSelection, value]
              : currentSelection.filter(c => c !== value);
          setCurrentSelection(selection);
          setChoices(applyCheckedOptions(selection));
        }}
      />
    </CCXPBaseDrop>
  );
};

export default CCXPMultiSelect;
